import React from 'react';
import PropTypes from 'prop-types';
import { ConfirmPopup } from './../../common/popup';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { REDUCER_NAME, notifySaveWatchList } from './reducer';

class NotifySaveWatchList extends React.Component {
  render() {
    const { isShow, messages, notifySaveWatchList, title } = this.props;

    return (
      <ConfirmPopup
        title={title ? title : 'message.server_error'}
        messages={messages}
        isShow={isShow}
        confirm={notifySaveWatchList}
        enabledApply={false}
        enabledCancel={false}
        iconName={'icon-warning'}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    isShow: state[REDUCER_NAME].notifySaveListWatchList.isShow,
    messages: state[REDUCER_NAME].notifySaveListWatchList.messages,
    title: state[REDUCER_NAME].notifySaveListWatchList.title,
  };
};

const mapDispatchToProps = {
  notifySaveWatchList,
};

NotifySaveWatchList.propTypes = {
  isShow: PropTypes.bool.isRequired,
  messages: PropTypes.array.isRequired,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(NotifySaveWatchList);
